import { TPostState } from '../../../../types/post';
import { buildPostUrl } from '../../../../utils';
import { EStatus, EType } from '../../../../repositories/journal/entities/journal/JournalAttributesSchema';

/** Возвращает набор seo-параметров из поста */
export const getPostMeta = (post: TPostState) => {
  if (!('id' in post)) {
    return;
  }

  const {
    id,
    attributes: { type, slug, seoTitle, seoDescription, seoKeywords, image, noIndex, status },
  } = post;

  return {
    title: seoTitle || '',
    description: seoDescription || '',
    keywords: seoKeywords || '',
    url: buildPostUrl({ type, slug, id }),
    image: image || '',
    noIndex: Boolean(noIndex) || ([EType.Blogs, EType.Questions].includes(type) && status !== EStatus.Checked),
  };
};
